import { BrowserNotSupported } from '@components/BrowserNotSupported';
import { isBrowserAccepted } from '@helpers/browser.helpers';

export function BrowserBlocker({ children }: { children: React.ReactNode }) {
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return isBrowserAccepted() ? <>{children}</> : <BrowserNotSupported />;
}
